import { AppChargeType, AppPricePlan, AppPricePlanDetailsType } from '../../types/generated';

export const getDisplayPrice = (pricePlan: AppPricePlan): string => {
    if (pricePlan.yearlyAmount! > 0) {
        return `$${pricePlan.yearlyAmount!}/yearly`;
    }

    if (pricePlan.monthlyAmount! > 0) {
        return `$${pricePlan.monthlyAmount!}/monthly`;
    }

    return 'Free';
};

export const sortPricePlansByPrice = (
    pricePlans: AppPricePlanDetailsType[]
): AppPricePlanDetailsType[] => {
    return pricePlans.sort((a, b) => {
        const aPlan = a.plan || { monthlyAmount: 0, yearlyAmount: 0 };
        const bPlan = b.plan || { monthlyAmount: 0, yearlyAmount: 0 };
        const aSum = aPlan.monthlyAmount! * 12 + aPlan.yearlyAmount!;
        const bSum = bPlan.monthlyAmount! * 12 + bPlan.yearlyAmount!;

        return aSum < bSum ? -1 : aSum === bSum ? 0 : 1;
    });
};

export const getAppDetailsPriceTextForPaxFlow = (
    chargeType: AppChargeType,
    oneTimeChargeAmount: Number,
    pricePlans: AppPricePlanDetailsType[],
    freeTrialDays: Number
): string => {
    switch (chargeType) {
        case AppChargeType.FreeToInstall:
            return 'Free to install. Additional charges may apply.';
        case AppChargeType.OneTime:
            if (oneTimeChargeAmount === 0) {
                return 'Free';
            }
            return `One time fee of $${oneTimeChargeAmount}`;
        case AppChargeType.Recurring: {
            if (pricePlans.length === 0) {
                return 'Invalid price';
            }
            const hasTrial = freeTrialDays > 0 ? ` ${freeTrialDays} day free trial` : undefined;
            return `${hasTrial || ''}`;
        }
        default:
            return 'N/A';
    }
};

export const getAppOverviewPriceType = (
    chargeType: AppChargeType,
    oneTimeChargeAmount: Number,
    pricePlans: AppPricePlanDetailsType[],
    freeTrialDays: Number
): string => {
    switch (chargeType) {
        case AppChargeType.FreeToInstall:
            return 'Free to install';
        case AppChargeType.OneTime:
            if (oneTimeChargeAmount === 0) {
                return 'Free';
            }
            return `One time fee of $${oneTimeChargeAmount}`;
        case AppChargeType.Recurring: {
            if (pricePlans.length === 0) {
                return 'Invalid price';
            }

            const sortedPricePlans = sortPricePlansByPrice(pricePlans);
            const cheapestPricePlan = sortedPricePlans[0].plan;
            const yearlyAmount = cheapestPricePlan!.yearlyAmount!;
            const monthlyAmount = cheapestPricePlan!.monthlyAmount!;

            if (
                (yearlyAmount === 0 && monthlyAmount === 0) ||
                (yearlyAmount === null && monthlyAmount === 0) ||
                (yearlyAmount === 0 && monthlyAmount === null)
            ) {
                if (sortedPricePlans.length === 1) {
                    return 'Free';
                } else {
                    return 'Free plan available';
                }
            }

            if (freeTrialDays > 0) {
                return `${freeTrialDays} day free trial`;
            }

            return getDisplayPrice(cheapestPricePlan!);
        }
        default:
            return 'N/A';
    }
};
